import axios from "axios";


const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const RUNTIME_ORIGIN = typeof window !== "undefined" ? window.location.origin : BACKEND_URL;
const API_ORIGIN = RUNTIME_ORIGIN || BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_ORIGIN}/api`,
  withCredentials: true,
});


export const createApplicationFeeYocoCheckout = () => api.post("/payments/application-fee/yoco/checkout");


export const getApplicationFeeYocoPaymentResult = (paymentId) => api.get(`/payments/application-fee/yoco/result/${paymentId}`);


export const getErrorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") {
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg || item?.message || JSON.stringify(item))
      .join(" ");
  }
  if (detail && typeof detail === "object") {
    return detail.message || JSON.stringify(detail);
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  return fallback;
};